export default "__VITE_ASSET__6HjcL_fi__"